import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-chips',
  template: `
  <p-chips [formControl]="formControl" [placeholder]="placeholder" [formlyAttributes]="field"></p-chips>`,
  styleUrls: ['./chips.component.less']
})
export class ChipsComponent extends FieldType {

  constructor() {
    super();
   }

  ngOnInit(): void {
  }

  public get placeholder() { return this.to.placeholder !== undefined ? this.to.placeholder : ''; }
  onChange($event: any) {
    if (this.to.onChange) {
      this.to.onChange($event, this.field);
    }
  }

}
